import React from 'react'
import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import actionType from '../../../Redux/Actions/ActionTypes';
import {LoadRegistrastionJournyData} from "../../../Redux/Actions/Actions";
import notify from '../../../Notifications/ToastifyActions';

function SWAddNewCommentAttachmentService(token,data) {
    return axios.post(`${CURRENT_API_URL}/swhelpdesk/SWAddNewCommentAttachment`, data,{
    headers: {
        'Authorization': token,
    }
    }).then(res => {
        notify.NotifySuccess("Your ticket has been assigned successfully. Thank You!");       
        return res.data;        
    }).catch(error => {
        console.log(error);
        notify.NotifyError("An error occurred while adding new comment and attachments. please try again later.");
        return false;
    });
}

export default SWAddNewCommentAttachmentService;